import { setIsAppUpdateScheduledToStorage } from './set-is-app-update-scheduled-to-storage';

export const updateApp = (): void => {
  setIsAppUpdateScheduledToStorage(false);
  window.location.reload();
};
